// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"61":"construction","177":"home","245":"notfound","327":"singlenews"}[chunkId] + "." + {"61":"5a854417","177":"13f4d567","245":"c9cf05ff","327":"fd02d588"}[chunkId] + ".js";
};